async function Post_fetch(input_map) {
    try {
        let resp = await fetch(input_map.url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
        
            }, body: JSON.stringify(input_map.body)
        })
        alert(JSON.stringify(input_map))
    } catch (e) {
        console.log("Catch Error: ", e)
    }
}

const FormAPI = { 
    Post_fetch,
};
export { FormAPI };
